"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// isFinite,
var isNil = function (value) {
    /**
     * isNil(null) => true
     * isNil() => true
     */
    return value === null || value === undefined;
};
exports.default = isNil;
//# sourceMappingURL=is-nil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-nil.js
// module id = 263
// module chunks = 37